import { createStore } from "vuex";
import { auth } from "./auth.module";
import { routes } from "./routes.module";
import { loader } from "@/store/loader.module";


const store = createStore({
  modules: {
    auth,
    loader,
    routes,
    /*acs,*/
  },
});

export default store;